import { React, useContext } from "react";
import { TbFilterDown } from "react-icons/tb";
import { FilterContext } from "../../context/Filter";

const Filteraccordion = ({ absolute }) => {
  const { isOpen, setIsOpen } = useContext(FilterContext);
  return (
    <TbFilterDown
      title={isOpen ? "Hide Search" : "Show Search"}
      className={`${absolute} text-blue-900 cursor-pointer {props.props} text-xl top-[-2rem] right-4 text-blue-800 hover:text-blue-900 transition-transform transform animate-text-blink`}
      onClick={() => setIsOpen(!isOpen)}
    />
  );
};

export default Filteraccordion;
